import { StreamId } from "@common/domain";

export class MixerStreamDeleteCmd {
  constructor(readonly streamId: StreamId) {}
}
